module.exports = "/_next/static/images/game-1-phone-avatar-rory-fbdd95a1a7b3fb67eda314f470e60028.jpg";